<template>
    <div>
        <div class="columns">
            <div class="column">
                <b-field label="Flat Price" label-position="inside">
                    <b-input v-model="price.flat_price" placeholder="0.00"></b-input>
                </b-field>
            </div>
            <div class="column">
                <b-field label="Price-per-Unit" label-position="inside">
                    <b-input v-model="price.per_unit_price" placeholder="0.00"></b-input>
                </b-field>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <b-field label="Enabled Date (Registration)" label-position="inside">
                    <b-datetimepicker
                        v-model="price.enabled_at"
                        placeholder="Click to set..."
                        position="is-top-left"
                        trap-focus
                        append-to-body
                        expanded
                    >
                    </b-datetimepicker>
                    <p class="control">
                        <b-button type="is-warning" outlined @click="price.enabled_at = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                    </p>
                </b-field>
            </div>
            <div class="column">
                <b-field label="Disabled Date (Registration)" label-position="inside">
                    <b-datetimepicker
                        v-model="price.disabled_at"
                        placeholder="Click to set..."
                        position="is-top-left"
                        trap-focus
                        append-to-body
                        expanded
                    >
                    </b-datetimepicker>
                    <p class="control">
                        <b-button type="is-warning" outlined @click="price.disabled_at = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                    </p>
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PriceScheduleForm",
        props: {
            price: {
                type: Object,
                required: true
            }
        },
    }
</script>

<style scoped lang="scss">

</style>
